import React from "react";
import { required, SelectInput, TextInput } from "react-admin";
import { Grid, IconButton } from "@mui/material";
import { doFlex, labelChoices } from "./styles";
import { Close as CloseIcon } from "@mui/icons-material";
import { useContacts } from "./ContactContext";
import config from "../../config";
import InputAdornment from "@mui/material/InputAdornment";
import CountrySelect from "./CountrySelect";
import { useFormContext, useFieldArray } from "react-hook-form";

const apiUrl = config.apiUrl;

const ContactNumberSection = ({ index, phoneNumber, contactPersonIndex }) => {
    const { deletePhoneNumber, updateContactNumberField } = useContacts();
    const sanitizePhoneNumber = (value) => value.replace(/[^0-9]/g, "").replace(/^0+/, "");
    const { control } = useFormContext();
    const { fields, append, remove } = useFieldArray({
        control,
        name: `contacts[${contactPersonIndex}].phoneNumbers`, 
    });
    const validatePhoneNumber = (value, allValues) => {
        const contact = allValues.contacts[contactPersonIndex];
        // if (contact.phoneNumbers[index].label && !value) {
        //     return "Phone number is required when label is selected";
        // }

        const currentPhone = contact.phoneNumbers[index];
        if (contact.phoneNumbers.length <= 1 && ((currentPhone.countryCode && currentPhone.countryCode !== "49") || currentPhone.phone_number_type) && !value) {
            return "Please enter a phone number";
        }

        return undefined;
    };
    const defaultLabel = phoneNumber?.phone_number_type || "work";
    const handleCountryCodeChange = (event) => {
        updateContactNumberField(contactPersonIndex, index, 'countryCode', event.target.value);
    };

    const handlePhoneNumberChange = (event) => {
        const sanitizedValue = sanitizePhoneNumber(event.target.value);
        updateContactNumberField(contactPersonIndex, index, 'phoneNumber', sanitizedValue);
    };

    const handleLabelChange = (event) => {
        updateContactNumberField(contactPersonIndex, index, 'phone_number_type', event.target.value);
    };

    const handleDeletePhoneNumber = async (contactPersonIndex, index, phoneNumberId) => {
        remove(index);
        deletePhoneNumber(contactPersonIndex, index);
        try {
            const response = await fetch(`${apiUrl}?section=kundenlistes&action=deletePhoneNumber&id=${phoneNumberId}`, {
                method: "POST",
            });
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            const result = await response.json();
            console.log("Phone number deleted successfully", result);
        } catch (err) {
            console.error("Phone number not deleted", err);
        }
    };

    return (
        <>
            <Grid item xs={12} md={3} style={doFlex} marginTop={"10px"}>
                <CountrySelect source="contacts" contactPersonIndex={contactPersonIndex} phoneNumberIndex={index} defaultValue={"49"} phoneNumber={phoneNumber} onChange={handleCountryCodeChange}></CountrySelect>
            </Grid>
            <Grid item xs={12} md={5} flexGrow={1} style={doFlex} marginTop={"14px"}>
                <TextInput
                    source={`contacts[${contactPersonIndex}].phoneNumbers[${index}].phoneNumber`}
                    label="Telefonnummer"
                    defaultValue={phoneNumber ? phoneNumber.phoneNumber : ""}
                    fullWidth
                    helperText={false}
                    size="large"
                    validate={validatePhoneNumber}
                    onChange={(event) => {
                        handlePhoneNumberChange(event);
                        const sanitizedValue = sanitizePhoneNumber(event.target.value);
                        event.target.value = sanitizedValue;
                    }}
                    parse={(value) => sanitizePhoneNumber(value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment
                                position="start"
                                sx={{
                                    padding: "4px",
                                    borderRadius: "4px",
                                }}
                            >
                                <span>+{phoneNumber.countryCode || "49"}</span>
                            </InputAdornment>
                        ),
                    }}
                />
            </Grid>
            <Grid item xs={12} md={4} style={doFlex} marginTop={"10px"}>
                <SelectInput source={`contacts[${contactPersonIndex}].phoneNumbers[${index}].phone_number_type`} choices={labelChoices} label="Label" defaultValue={defaultLabel} helperText={false} validate={required()} sx={{ marginBottom: "4px" }} onChange={handleLabelChange} fullWidth size="large" disableEmpty />
            </Grid>
            <Grid item xs={12} md={12} style={doFlex} marginTop={"14px"}>
                {/* {index > 0 && ( */}
                    <IconButton onClick={() => handleDeletePhoneNumber(contactPersonIndex, index, phoneNumber.id)} color="error" size="small">
                        <CloseIcon fontSize="small" />
                    </IconButton>
                {/* )} */}
            </Grid>
        </>
    );
};
export default ContactNumberSection;